import { HV_TAKEOVER_GRID_ID } from '@/lib/constants/addresses';

/** Legacy query on `/lobby` for the active board (`?board=…`). Canonical URLs use `/board/:boardId`. */
export const BOARD_QUERY_PARAM = 'board';

/** Default lobby URL — the boardroom lobby lives at `/lobby` (the
 *  marketing homepage owns `/`). */
export const DEFAULT_LOBBY_PATH = '/lobby';

/** Map Envio / ticker composite grid id to the lobby `MockBoard.id` (Boardroom → `boardroom`). */
export function lobbyBoardIdFromGridId(gridId: string): string {
  if (gridId === HV_TAKEOVER_GRID_ID) return 'boardroom';
  return gridId;
}

/**
 * Canonical lobby URL for a board.
 * Boardroom uses `/lobby`; other boards use `/board/{id}`.
 * `id` is the lobby board id — either the `boardroom` sentinel or a
 * live composite `0x…-n` grid id from `/api/v1/grids`.
 */
export function lobbyPathForBoard(boardId: string): string {
  if (boardId === 'boardroom') return '/lobby';
  return `/board/${encodeURIComponent(boardId)}`;
}

/**
 * Deep link to the lobby with a board selected (client navigation, no full
 * document reload).
 *
 * Mobile lobby caveat: `LobbyClient` defaults `/lobby` (with no `?mode=…`)
 * to the full-bleed lobby directory on small viewports, so a plain
 * `/lobby` href would land mobile users on the directory instead of the
 * Boardroom canvas — same issue users hit on the previous `/` homepage
 * when tapping the Boardroom pill in the global activity ticker. Routing
 * the Boardroom URL through `?mode=board` (the explicit "show the canvas"
 * sentinel that beats the mobile lobby default; also written by
 * `LobbyClient.setActiveBoardId` when the Boardroom card is tapped
 * from the directory) makes the link land on the canvas regardless
 * of viewport. The query param is harmless on desktop where there's
 * no implicit lobby mode.
 */
export function lobbyHrefForBoard(boardId: string): string {
  if (boardId === 'boardroom') return '/lobby?mode=board';
  return lobbyPathForBoard(boardId);
}
